var __glob = (map) => (path) => {
  var fn = map[path];
  if (fn) return fn();
  throw new Error("Module not found in bundle: " + path);
};

// src/resources/index.ts
import LanguageLocales from "@helsenorge/core-utils/constants/languages";
import { getModifiedResourcesForTest } from "@helsenorge/framework-utils/resources";
import frameworkNbNo from "./HN.Core.Framework.NPM.JS.nb-NO.json";
import contentNbNo from "./HN.Tjenester.Content.nb-NO.json";

// import("./**/*.*.json") in src/resources/index.ts
var globImport_json = __glob({
  "./HN.Core.Framework.NPM.JS.en-GB.json": () => import("./HN.Core.Framework.NPM.JS.en-GB.json"),
  "./HN.Core.Framework.NPM.JS.lt-LT.json": () => import("./HN.Core.Framework.NPM.JS.lt-LT.json"),
  "./HN.Core.Framework.NPM.JS.nb-NO.json": () => import("./HN.Core.Framework.NPM.JS.nb-NO.json"),
  "./HN.Core.Framework.NPM.JS.nn-NO.json": () => import("./HN.Core.Framework.NPM.JS.nn-NO.json"),
  "./HN.Core.Framework.NPM.JS.pl-PL.json": () => import("./HN.Core.Framework.NPM.JS.pl-PL.json"),
  "./HN.Core.Framework.NPM.JS.ro-RO.json": () => import("./HN.Core.Framework.NPM.JS.ro-RO.json"),
  "./HN.Core.Framework.NPM.JS.ru-RU.json": () => import("./HN.Core.Framework.NPM.JS.ru-RU.json"),
  "./HN.Core.Framework.NPM.JS.se-NO.json": () => import("./HN.Core.Framework.NPM.JS.se-NO.json"),
  "./HN.Tjenester.Content.en-GB.json": () => import("./HN.Tjenester.Content.en-GB.json"),
  "./HN.Tjenester.Content.nb-NO.json": () => import("./HN.Tjenester.Content.nb-NO.json"),
  "./HN.Tjenester.Content.nn-NO.json": () => import("./HN.Tjenester.Content.nn-NO.json"),
  "./HN.Tjenester.Content.se-NO.json": () => import("./HN.Tjenester.Content.se-NO.json")
});

// src/resources/index.ts
var Projects = {
  FRAMEWORK: "HN.Core.Framework.NPM.JS",
  CONTENT: "HN.Tjenester.Content"
};
var getResourceItem = (projectName, language) => {
  if (projectName === Projects.FRAMEWORK && language === LanguageLocales.NORWEGIAN) {
    return frameworkNbNo;
  }
  if (projectName === Projects.CONTENT && language === LanguageLocales.NORWEGIAN) {
    return contentNbNo;
  }
};
var getResources = async (projectName, language) => {
  const resources = getResourceItem(projectName, language);
  if (resources) {
    return Promise.resolve(resources);
  }
  try {
    const resources2 = await globImport_json(`./${projectName}.${language}.json`);
    return resources2.default;
  } catch (error) {
    throw new Error(`Failed to load resources for ${projectName} in ${language}: ${error}`);
  }
};
var getResourcesTestHelper = async (projectName, language) => {
  const resources = await getResources(projectName, language);
  if (resources) {
    return getModifiedResourcesForTest(resources);
  }
  throw new Error(`Mangler ressurs ${projectName}.${language}`);
};
export {
  Projects,
  getResources,
  getResourcesTestHelper
};
